import React, { useEffect, useState, useContext } from "react";
import AddSecret from "components/AddSecret/AddSecret";
import Drawer from "components/Drawer/index";
import Modal from "components/Models/index";
import useScreenMobile from "hooks/useScreen";
import "./secretManagement.scss";
import { signInContext } from "context/SigninContext";
import DeviceManagement from "./DeviceManagement";
import { callUpdatePin, addKVPair, listKVPairs, updateKVPair, addPassword, updatePassword, listPasswords, listPrivateKeys, listCertificates, addPrivateKey, updatePrivateKey, addCertificate, updateCertificate, addYsafePIN, addToken, updateToken, listTokens, callListPins } from "./helper";
// import EmptySecret from "components/EmptySecret/EmptySecret";
import { useToast } from "components/Toaster/index";

// This is the format of the Add Secret Form
const initialFormData = {
  addNewData: true,
  inputs: {
    secretPath: null,
    description: null,
    password: null,
    file: null,
    minSize: null,
    maxSize: null,
    pin: null,
    url: null,
    username: null,
    totp: null,
    key: null,
    tokenKey: null,
    generatedSecret: null,
    keyValuePairs: [
      {
        key: null,
        value: null
      }
    ],
    checkboxes: {
      autoRotate: null,
      encryptAtRest: null,
      restrictAttestedCode: null
    },
    //  the below is for allowed objects in pin
    allowedObjects: [] // Array of selected object UUIDs
  },
  selects: {
    selectedSecretType: null,
    selectedSecretValueTTL: null,
    selectedTTL: null,
    selectedExpireAlert: null,
    autoRotateTTL: null,
    keyInputMethod: null,
    selectedOperations: null
  }
};

const SecretManagement = ({ searchQuery = "", setActiveCard }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [secretsList, setSecretsList] = useState([]);
  const tabIconKeys = [
    "Ysafe PIN",
    "token",
    "certificate",
    "keys",
    "keyValue",
    "password"
  ];
  const { isTypeSelect } = useContext(signInContext);
  const showToast = useToast();
  const [activeTabKey, setActiveTabKey] = useState(tabIconKeys[0]);
  const fetchSecrets = async () => {
    try {
      let temp;
      let typeOfSecret;
      if (activeTab == 0) {
        // should use addPin call

        temp = await callListPins();
        typeOfSecret = "Ysafe PINS";
      }
      if (activeTab == 1) {
        temp = (await listTokens());

        typeOfSecret = "Tokens";
      }
      if (activeTab == 2) {
        temp = (await listCertificates());
        typeOfSecret = "Certificates";

      }
      if (activeTab == 3) {
        temp = (await listPrivateKeys());
        typeOfSecret = "Private Keys";
      }

      if (activeTab == 4) {
        temp = (await listKVPairs());
        typeOfSecret = "Key Value pairs";
      }
      if (activeTab == 5) {
        temp = (await listPasswords());
        typeOfSecret = "Passwords";
      }
      // console.log("secret items are ", temp);
      const newSecretsList = [];
      (temp || []).forEach((secretItem) => {
        if (activeTab === 0) {
          const creationTime = secretItem.creationTime;
          const creationTimeStr = creationTime
            ? `PIN created at ${creationTime}`
            : "";
          const expiryTimeString = secretItem.expiryTime ? `PIN expires at ${secretItem.expiryTime}` : "";
          //  print the index,creationtime,secretitem.name
          newSecretsList.push({
            addNewData: false,
            inputs: {
              secretPath: null,
              description: creationTimeStr,
              password: null,
              file: null,
              minSize: null,
              maxSize: null,
              // pin: secretItem.pin || null,
              operations_allowed: secretItem.allowedPinOpsNames || null,
              url: secretItem.client || null,
              username: null,
              totp: null,
              key: secretItem.name || null,
              tokenKey: secretItem.Id || secretItem.id || (typeof secretItem.getId === 'function' ? secretItem.getId() : null),
              generatedSecret: null,
              keyValuePairs: null,
              checkboxes: {
                autoRotate: null,
                encryptAtRest: null,
                restrictAttestedCode: null
              }
            },
            selects: {
              selectedSecretType: typeOfSecret,
              selectedSecretValueTTL: null,
              selectedTTL: expiryTimeString || null,
              selectedExpireAlert: null,
              autoRotateTTL: null,
              keyInputMethod: null,
              selectedOperations: null
            }
          });
        } else {
          // Handle keyValuePairs from .keys() and .values() if available
          const data = secretItem?.get_data?.()?.get_keyvalue?.();
          let keyValuePairs;
          if (data) {
            const keys = data.get_key();
            const values = data.get_value();
            keyValuePairs = keys.map((key, idx) => ({
              key,
              value: values[idx]
            }));
          } else {
            keyValuePairs = [{
              key: "",
              value: ""
            }];
          }
          newSecretsList.push({
            addNewData: false,
            inputs: {
              secretPath: secretItem?.get_path?.() || "",
              description: secretItem?.get_description?.() || "",
              password: secretItem?.get_data?.()?.get_password?.()?.get_password() || null,
              file: null,
              minSize: secretItem?.get_min_size?.() || null,
              maxSize: secretItem?.get_max_size?.() || null,
              pin: null,
              url: secretItem?.get_data?.()?.get_password?.()?.get_url() || null,
              username: secretItem?.get_data?.()?.get_password?.()?.get_username() || null,
              totp: secretItem?.get_data?.()?.get_password?.()?.get_totp_secret?.() || null,
              key: (() => {
                let keyValue = [];
                if (activeTab === 3) {
                  keyValue = secretItem?.get_data?.().get_private_key?.()?.get_value?.();
                }
                if (activeTab === 2) {
                  keyValue = secretItem?.get_data?.().get_certificate?.()?.get_value?.();
                }
                if (activeTab === 1) {
                  keyValue = secretItem?.get_data?.().get_key?.()?.get_key?.();
                }
                if (keyValue && (keyValue instanceof Uint8Array || keyValue instanceof ArrayBuffer)) {
                  return new TextDecoder().decode(keyValue);
                }
                return keyValue || null;
              })(),
              tokenKey: (() => {
                const tokenValue = secretItem?.get_data?.().get_key?.()?.get_key?.();
                if (tokenValue && (tokenValue instanceof Uint8Array || tokenValue instanceof ArrayBuffer)) {
                  return new TextDecoder().decode(tokenValue);
                }
                return tokenValue || null;
              })(),
              generatedSecret: null,
              keyValuePairs: keyValuePairs,
              checkboxes: {
                autoRotate: secretItem.get_auto_rotate?.() || false,
                encryptAtRest: secretItem.get_encrypt_at_rest?.() || false,
                restrictAttestedCode: secretItem.get_restrict_attested_code?.() || false
              }
            },
            selects: {
              selectedSecretType: typeOfSecret,
              selectedSecretValueTTL: secretItem.get_secret_value_ttl?.() || "Generate",
              selectedTTL: secretItem.get_expiry?.() || null,
              selectedExpireAlert: secretItem.get_expire_alert?.() || "1 Day before",
              autoRotateTTL: secretItem.get_auto_rotate_ttl?.() || null,
              keyInputMethod: secretItem.get_key_input_method?.() || null,
              selectedOperations: secretItem.get_selected_operations?.() || null
            }
          });
        }
      });
      setSecretsList(newSecretsList);
    }
    catch (error) {
      console.error("Error fetching secrets:", error);
      showToast("Error while fetching secrets", "error");
    }
  };

  useEffect(() => {
    setSecretsList([]);
    fetchSecrets();
    setActiveTabKey(tabIconKeys[activeTab]);
  }, [activeTab]);
  useEffect(() => {


  }, [secretsList]);

  const [openAddSecret, setOpenAddSecret] = useState(false);
  // temporarily store the form Data
  const [formData, setFormData] = useState(initialFormData);

  const [formErrors, setFormErrors] = useState({});
  // This is for displaying the Table Datas
  const isMobile = useScreenMobile({ size: 992 });
  const handleCreateSecretModal = () => {
    setFormData(initialFormData);
    setFormErrors({});
    setOpenAddSecret(true);
  };

  // Register handler for homepage header Add button (similar to Files)
  useEffect(() => {
    window.secretsManagementProps = {
      handleCreateSecretModal
    };
    // Cleanup on unmount
    return () => {
      window.secretsManagementProps = null;
    };
  }, []);
  const [token, setToken] = useState("");

  useEffect(() => {
    const isDeletePinRuntimeError = (message = "") => {
      const msg = String(message || "").toLowerCase();
      return (
        msg.includes("delete pin") ||
        msg.includes("failed to delete pin")
      );
    };

    const handleUnhandledRejection = (event) => {
      const reason = event?.reason;
      const message =
        reason?.message ||
        (typeof reason === "string" ? reason : "");

      if (isDeletePinRuntimeError(message)) {
        event.preventDefault();
      }
    };

    const handleWindowError = (event) => {
      const message = event?.message || event?.error?.message || "";

      if (isDeletePinRuntimeError(message)) {
        event.preventDefault();
      }
    };

    window.addEventListener("unhandledrejection", handleUnhandledRejection);
    window.addEventListener("error", handleWindowError);

    return () => {
      window.removeEventListener("unhandledrejection", handleUnhandledRejection);
      window.removeEventListener("error", handleWindowError);
    };
  }, []);
  // const validateForm = () => {
  //   const errors = {};
  //   const { inputs, selects } = formData;

  //   if (!selects.selectedSecretType) errors.selectedSecretType = "Required";
  //   if (!inputs.secretPath?.trim()) errors.secretPath = "Required";
  //   if (!selects.selectedSecretValueTTL)
  //     errors.selectedSecretValueTTL = "Required";

  //   if (selects.selectedSecretValueTTL === "Upload Binary File") {
  //     if (!inputs.file) errors.file = "Please select a file";
  //   } else {
  //     if (!inputs.password?.trim()) {
  //       errors.password = "Required";
  //     } else if (inputs.password.length < 8) {
  //       errors.password = "Password must be at least 8 characters";
  //     }
  //   }

  //   if (!selects.selectedTTL) errors.selectedTTL = "Required";
  //   if (!selects.selectedExpireAlert) errors.selectedExpireAlert = "Required";

  //   if (inputs.checkboxes.autoRotate && !selects.autoRotateTTL) {
  //     errors.autoRotateTTL = "Required";
  //   }

  //   setFormErrors(errors);
  //   return Object.keys(errors).length === 0;
  // };
  const [showToken, setShowToken] = useState(false);
  const isAddButtonDisabled = (() => {
    if (activeTab !== 0) return false;

    const pinNameFilled = Boolean(formData.inputs.key?.trim());
    const pinFilled = Boolean(formData.inputs.pin?.trim());
    const ttlSelected = Boolean(formData.selects.selectedTTL);
    const operationsSelected = Array.isArray(formData.selects.selectedOperations) &&
      formData.selects.selectedOperations.length > 0;

    return !(pinNameFilled && pinFilled && ttlSelected && operationsSelected);
  })();

  // Add this function to your SecretManagement component
  // const downloadBinaryToken = (tokenData, fileName = "ysafe_pin") => {
  //   //  print the type of tokendata
  //   console.log("Downloading token with data type:", typeof tokenData);
  //   try {
  //     let binaryData;
  //     // Handle object with numeric keys (like your example)
  //     if (
  //       tokenData &&
  //       typeof tokenData === "object" &&
  //       !Array.isArray(tokenData) &&
  //       Object.keys(tokenData).every(k => !isNaN(Number(k)))
  //     ) {
  //       // Convert object with numeric keys to Uint8Array
  //       const arr = [];
  //       for (let i = 0; i < Object.keys(tokenData).length; i++) {
  //         arr.push(tokenData[i]);
  //       }
  //       binaryData = new Uint8Array(arr);
  //     } else if (tokenData instanceof Uint8Array) {
  //       binaryData = tokenData;
  //     } else if (typeof tokenData === "string") {
  //       // If hex string, convert to binary
  //       const hex = tokenData.replace(/\s/g, "");
  //       binaryData = new Uint8Array(
  //         hex.match(/.{1,2}/g)?.map(byte => parseInt(byte, 16)) || []
  //       );
  //     } else if (Array.isArray(tokenData)) {
  //       binaryData = new Uint8Array(tokenData);
  //     } else {
  //       console.error("Unsupported token format:", typeof tokenData);
  //       showToast("Cannot download token in this format", "error");
  //       return;
  //     }

  //     const blob = new Blob([binaryData], { type: "application/octet-stream" });

  //     if ("showSaveFilePicker" in window) {
  //       window.showSaveFilePicker({
  //         suggestedName: `${fileName}.bin`,
  //         types: [{
  //           description: "Binary Token",
  //           accept: { "application/octet-stream": [".bin"] }
  //         }]
  //       }).then(fileHandle => {
  //         fileHandle.createWritable().then(writable => {
  //           writable.write(blob).then(() => {
  //             writable.close().then(() => {
  //               showToast("Token saved successfully", "success");
  //             });
  //           });
  //         });
  //       }).catch(err => {
  //         if (err.name !== "AbortError") {
  //           console.error("Error saving file:", err);
  //           showToast("Failed to save token", "error");
  //         }
  //       });
  //     } else {
  //       const url = URL.createObjectURL(blob);
  //       const a = document.createElement("a");
  //       a.href = url;
  //       a.download = `${fileName}.bin`;
  //       document.body.appendChild(a);
  //       a.click();
  //       document.body.removeChild(a);
  //       URL.revokeObjectURL(url);
  //       showToast("Token download started", "success");
  //     }
  //   } catch (error) {
  //     console.error("Error downloading token:", error);
  //     showToast("Failed to download token", "error");
  //   }
  // };

  // const downloadBase64Token = (tokenData, fileName = "ysafe_pin") => {
  //   console.log("Downloading token as base64 with data type:", typeof tokenData);
  //   try {
  //     let binaryData;

  //     // Handle different token formats - same as your binary function
  //     if (
  //       tokenData &&
  //       typeof tokenData === "object" &&
  //       !Array.isArray(tokenData) &&
  //       Object.keys(tokenData).every(k => !isNaN(Number(k)))
  //     ) {
  //       // Convert object with numeric keys to Uint8Array
  //       const arr = [];
  //       for (let i = 0; i < Object.keys(tokenData).length; i++) {
  //         arr.push(tokenData[i]);
  //       }
  //       binaryData = new Uint8Array(arr);
  //     } else if (tokenData instanceof Uint8Array) {
  //       binaryData = tokenData;
  //     } else if (typeof tokenData === "string") {
  //       // If hex string, convert to binary
  //       const hex = tokenData.replace(/\s/g, "");
  //       binaryData = new Uint8Array(
  //         hex.match(/.{1,2}/g)?.map(byte => parseInt(byte, 16)) || []
  //       );
  //     } else if (Array.isArray(tokenData)) {
  //       binaryData = new Uint8Array(tokenData);
  //     } else {
  //       console.error("Unsupported token format:", typeof tokenData);
  //       showToast("Cannot download token in this format", "error");
  //       return;
  //     }

  //     // Convert binary data to base64 string
  //     const base64String = btoa(
  //       Array.from(binaryData)
  //         .map(byte => String.fromCharCode(byte))
  //         .join("")
  //     );

  //     // Create text blob with the base64 string
  //     const blob = new Blob([base64String], { type: "text/plain" });

  //     if ("showSaveFilePicker" in window) {
  //       window.showSaveFilePicker({
  //         suggestedName: `${fileName}.txt`,
  //         types: [{
  //           description: "Text File",
  //           accept: { "text/plain": [".txt"] }
  //         }]
  //       }).then(fileHandle => {
  //         fileHandle.createWritable().then(writable => {
  //           writable.write(blob).then(() => {
  //             writable.close().then(() => {
  //               showToast("Base64 token saved successfully", "success");
  //             });
  //           });
  //         });
  //       }).catch(err => {
  //         if (err.name !== "AbortError") {
  //           console.error("Error saving file:", err);
  //           showToast("Failed to save base64 token", "error");
  //         }
  //       });
  //     } else {
  //       // Fallback for browsers without File System Access API
  //       const url = URL.createObjectURL(blob);
  //       const a = document.createElement("a");
  //       a.href = url;
  //       a.download = `${fileName}.txt`;
  //       document.body.appendChild(a);
  //       a.click();
  //       document.body.removeChild(a);
  //       URL.revokeObjectURL(url);
  //       showToast("Base64 token download started", "success");
  //     }
  //   } catch (error) {
  //     console.error("Error downloading base64 token:", error);
  //     showToast("Failed to download base64 token", "error");
  //   }
  // };

  // Replace your existing downloadBinaryToken function with this combined version
  const downloadTokenSequentially = (tokenData, fileName = "ysafe_pin", formats = ["binary", "base64"]) => {
    if (formats.length === 0) return; // Exit if no formats left

    const currentFormat = formats[0];
    const remainingFormats = formats.slice(1);

    // console.log(`Downloading token as ${currentFormat}`);

    try {
      let binaryData;
      // Convert token to binary data regardless of format
      if (tokenData && typeof tokenData === "object" && !Array.isArray(tokenData) &&
        Object.keys(tokenData).every(k => !isNaN(Number(k)))) {
        const arr = [];
        for (let i = 0; i < Object.keys(tokenData).length; i++) {
          arr.push(tokenData[i]);
        }
        binaryData = new Uint8Array(arr);
      } else if (tokenData instanceof Uint8Array) {
        binaryData = tokenData;
      } else if (typeof tokenData === "string") {
        const hex = tokenData.replace(/\s/g, "");
        binaryData = new Uint8Array(
          hex.match(/.{1,2}/g)?.map(byte => parseInt(byte, 16)) || []
        );
      } else if (Array.isArray(tokenData)) {
        binaryData = new Uint8Array(tokenData);
      } else {
        console.error("Unsupported token format:", typeof tokenData);
        showToast("Cannot download token in this format", "error");
        return;
      }
      let blob;
      let fileExt;
      let contentType;
      let description;

      if (currentFormat === "base64") {
        // For base64, convert binary to base64 string
        const base64String = btoa(
          Array.from(binaryData).map(byte => String.fromCharCode(byte)).join("")
        );
        blob = new Blob([base64String], { type: "text/plain" });
        fileExt = ".txt";
        contentType = "text/plain";
        description = "Text File";
      } else {
        // For binary
        blob = new Blob([binaryData], { type: "application/octet-stream" });
        fileExt = ".bin";
        contentType = "application/octet-stream";
        description = "Binary Token";
      }

      if ("showSaveFilePicker" in window) {
        window.showSaveFilePicker({
          suggestedName: `${fileName}${fileExt}`,
          types: [{
            description: description,
            accept: { [contentType]: [fileExt] }
          }]
        }).then(fileHandle => {
          return fileHandle.createWritable()
            .then(writable => {
              return writable.write(blob)
                .then(() => writable.close())
                .then(() => {
                  showToast(`Token saved as ${currentFormat}`, "success");

                  // After current download completes, start the next format
                  // with a small delay to ensure file picker is fully closed
                  if (remainingFormats.length > 0) {
                    setTimeout(() => {
                      downloadTokenSequentially(tokenData, fileName, remainingFormats);
                    }, 300);
                  }
                });
            });
        }).catch(err => {
          // If user cancels one format, try the next one
          if (err.name !== "AbortError") {
            console.error("Error saving file:", err);
            showToast(`Failed to save ${currentFormat} token`, "error");
          }

          // Continue with next format even on error
          if (remainingFormats.length > 0) {
            setTimeout(() => {
              downloadTokenSequentially(tokenData, fileName, remainingFormats);
            }, 300);
          }
        });
      } else {
        // Fallback for browsers without File System Access API
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${fileName}${fileExt}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        showToast(`${currentFormat} token download started`, "success");

        // For fallback method, we can continue immediately
        if (remainingFormats.length > 0) {
          setTimeout(() => {
            downloadTokenSequentially(tokenData, fileName, remainingFormats);
          }, 300);
        }
      }
    } catch (error) {
      console.error(`Error downloading ${currentFormat} token:`, error);
      showToast(`Failed to download ${currentFormat} token`, "error");

      // Try next format on error
      if (remainingFormats.length > 0) {
        setTimeout(() => {
          downloadTokenSequentially(tokenData, fileName, remainingFormats);
        }, 300);
      }
    }
  };



  const handleSaveAddSecret = async () => {
    // console.log("handleSaveAddSecret called with formData:", formData);


    try {
      if (activeTab === 0) {
        const ttl = formData.selects.selectedTTL === "1 Hour" ? 3600 :
          formData.selects.selectedTTL === "12 Hours" ? 43200 :
            formData.selects.selectedTTL === "1 Day" ? 86400 :
              formData.selects.selectedTTL === "7 Days" ? 604800 :
                formData.selects.selectedTTL === "30 Days" ? 2592000 :
                  1000; // default to 1000 if no match
        const pin = formData.inputs.pin;
        const selectedOperations = formData.selects.selectedOperations;
        const pinName = formData.inputs.key;
        const uuidsHexa = formData.inputs.allowedObjects;

        if (formData.addNewData) {
          if (!pinName || pinName === "N/A" || pinName === "") {
            showToast("Please enter a valid PIN name", "error");
            return;

          }
          const res = await addYsafePIN(isTypeSelect, ttl, pin, selectedOperations, pinName, uuidsHexa);

          setToken(res);
          setShowToken(true);
          // downloadBinaryToken(res,pinName);
          // downloadBase64Token(res,pinName);
          downloadTokenSequentially(res, pinName, ["binary", "base64"]);
        }
        else {
          // not implemented yet
          //  this must be edit

          // console.log("uuidsHexa are :", uuidsHexa);
          //  print the selected operations
          // console.log("selectedOperations are :", selectedOperations);
          //  also print the pin name
          // console.log("pinName is :", pinName);


          const res = await callUpdatePin(pinName, uuidsHexa, selectedOperations);
          // console.log("respone of addpin is :", res);

          setToken(res);
          setShowToken(true);

          // }
        }
      }
      if (activeTab === 1) {
        const path = formData.inputs.secretPath;
        const token = new TextEncoder().encode(formData.inputs.tokenKey);
        // const expiry = (1000); // formData.selects.selectedTTL
        const ttl = formData.selects.selectedTTL === "1 Hour" ? (3600) :
          formData.selects.selectedTTL === "12 Hours" ? (43200) :
            formData.selects.selectedTTL === "1 Day" ? (86400) :
              formData.selects.selectedTTL === "7 Days" ? (604800) :
                formData.selects.selectedTTL === "30 Days" ? (2592000) :
                  (1000); // default to 1000 if no match
        // encode token
        if (formData.addNewData) {// skipping min and max size for token
          await addToken(path, token, 0, 100, ttl);
        }
        else {
          await updateToken(path, token, 0, 100, ttl);
        }
      }
      if (activeTab === 2) {
        const path = formData.inputs.secretPath;
        const cert = formData.inputs.file;
        // const ttl = (1000); // formData.selects.selectedTTL
        const ttl = formData.selects.selectedTTL === "1 Hour" ? (3600) :
          formData.selects.selectedTTL === "12 Hours" ? (43200) :
            formData.selects.selectedTTL === "1 Day" ? (86400) :
              formData.selects.selectedTTL === "7 Days" ? (604800) :
                formData.selects.selectedTTL === "30 Days" ? (2592000) :
                  (1000); // default to 1000 if no match
        if (cert) {
          const fileSize = cert.size;
          const data = cert.slice(0, fileSize);
          formData.inputs.key = await data.arrayBuffer();
          const buffer = new Uint8Array(formData.inputs.key);
          // const text = new TextDecoder().decode(buffer);
          // console.log("File data:", text);
          if (formData.addNewData) {
            await addCertificate(path, buffer, ttl);
          }
          else {
            await updateCertificate(path, buffer, ttl);
          }
        }
      }
      if (activeTab === 3) {

        const path = formData.inputs.secretPath;
        // const minSize = formData.inputs.minSize;
        // const maxSize = formData.inputs.maxSize;
        const file = formData.inputs.file;
        const ttl = formData.selects.selectedTTL === "1 Hour" ? (3600) :
          formData.selects.selectedTTL === "12 Hours" ? (43200) :
            formData.selects.selectedTTL === "1 Day" ? (86400) :
              formData.selects.selectedTTL === "7 Days" ? (604800) :
                formData.selects.selectedTTL === "30 Days" ? (2592000) :
                  (1000); // default to 1000 if no match
        let key = formData.inputs.key;
        if (typeof key === "string") {
          key = new TextEncoder().encode(key);
        }
        if (file) {
          const fileSize = file.size;
          const data = file.slice(0, fileSize);
          key = new Uint8Array(await data.arrayBuffer());
        }
        if (formData.addNewData) {
          await addPrivateKey(path, key, ttl);
        }
        else {
          await updatePrivateKey(path, key, ttl);
        }
      }
      if (activeTab === 4) {
        const path = formData.inputs.secretPath;
        const keys = [];
        const values = [];
        formData.inputs.keyValuePairs.map((item) => {
          keys.push(item.key);
          values.push(item.value);
        });
        if (formData.addNewData) {
          await addKVPair(path, keys, values, (1000));
        }
        else {

          await updateKVPair(path, keys, values, (1000));
        }
      }
      else if (activeTab === 5) {
        const path = formData.inputs.secretPath;
        const username = formData.inputs.username;
        const password = formData.inputs.password;
        const url = formData.inputs.url;
        const totpSecret = formData.inputs.totp;
        const notes = formData.inputs.description || "";
        // const expiry = (1000); //formData.selects.selectedTTL
        const expiry = formData.selects.selectedTTL === "1 Hour" ? (3600) :
          formData.selects.selectedTTL === "12 Hours" ? (43200) :
            formData.selects.selectedTTL === "1 Day" ? (86400) :
              formData.selects.selectedTTL === "7 Days" ? (604800) :
                formData.selects.selectedTTL === "30 Days" ? (2592000) :
                  (1000); // default to 1000 if no match
        if (formData.addNewData) {
          await addPassword(path, username, password, url, totpSecret, "notes", expiry);
        }
        else {
          await updatePassword(path, username, password, url, totpSecret, notes, expiry);
        }

      }
      // if(formData.addNewData){
      if (activeTab === 0) {
        showToast(
          formData.addNewData
            ? "Ysafe PIN added successfully"
            : "Ysafe PIN edited successfully",
          "success"
        );
        await fetchSecrets();
      } else {

        setSecretsList((prev) => [...prev, formData]);
      }
      // }
    } catch (error) {
      showToast(error.message, "error");
      return;
    }
    setFormData(initialFormData);
    setFormErrors({});
    setOpenAddSecret(false);
    // }
  };

  return (
    <>
      <DeviceManagement
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        handleCreateSecretModal={handleCreateSecretModal}
        secretsList={secretsList}
        setSecretsList={setSecretsList}
        setFormData={setFormData}
        formData={formData}
        formErrors={formErrors}
        setFormErrors={setFormErrors}
        handleSaveAddSecret={handleSaveAddSecret}
        searchQuery={searchQuery}
        setActiveCard={setActiveCard}
      />
      {openAddSecret &&
        // false && // remove this line for screts to work
        (isMobile ? (
          <Drawer
            rightButtonWith="100%"
            cancelButton={false}
            isVisible={true}
            isDisabled={isAddButtonDisabled}
            handleSave={handleSaveAddSecret}
            heading={activeTabKey ? `Add ${activeTabKey} ` : "Add Secret"}
            handleCancel={() => setOpenAddSecret(false)}
            showHeader={true}
            mockClass="addSecret"
            submitBtnText="Add"
            showFooter={true}
          >
            <AddSecret
              updateOperation={false}
              activeTab={activeTab}
              setFormData={setFormData}
              formData={formData}
              formErrors={formErrors}
              setFormErrors={setFormErrors}
            />
          </Drawer>
        ) : (
          <Modal
            isVisible={openAddSecret}
            handleCancel={() => setOpenAddSecret(false)}
            heading={activeTabKey ? `Add ${activeTabKey} ` : "Add Secret"}
            showFooter={true}
            submitBtnText="Add"
            isDisabled={isAddButtonDisabled}
            handleSave={handleSaveAddSecret}
          >
            <AddSecret
              updateOperation={false}
              activeTab={activeTab}
              setFormData={setFormData}
              formData={formData}
              formErrors={formErrors}
              setFormErrors={setFormErrors}
            />
          </Modal>
        ))}
      {
        showToken && (
          false && // remove thi line for screts to work
          <Modal
            isVisible={showToken}
            handleCancel={() => {
              setShowToken(false);
              setToken("");
            }}
            heading="Token Generated"
            showFooter={true}
            submitBtnText="Copy"
            handleSave={() => {
              navigator.clipboard.writeText(token);
              setShowToken(false);
              setToken("");
            }}
          >
            <div
              style={{
                wordBreak: "break-all",
                background: "var(--gray-gray-8, #f5f5f5)",
                color: "var(--text-grey-neutral, #333)",
                padding: "16px",
                borderRadius: "8px",
                fontFamily: "monospace",
                fontSize: "1rem",
                margin: "12px 0",
                textAlign: "center",
                boxShadow: "0 1px 4px rgba(0,0,0,0.04)"
              }}
              className="modal-token-value"
            >
              {token}
            </div>
          </Modal>
        )
      }
    </>
  );
};

export default SecretManagement;



/* 



<Input
            label="Minimum Size"
            star="*"
            type="number"
            placeholder="Enter minimum size"
            inputKey="minSize"
            mockClass="secretInput"
            maxLength={10}
            value={formData.inputs.minSize}
            onChange={(e) => handleInputChange("minSize", e.target.value.replace(/\D/g, ""))}
            errorMessage={formErrors.minSize}
          />
          <Input

            label="Maximum Size"
            star="*"
            type="number"
            placeholder="Enter maximum size"
            inputKey="maxSize"
            mockClass="secretInput"
            maxLength={10}
            value={formData.inputs.maxSize}
            onChange={(e) => handleInputChange("maxSize", e.target.value.replace(/\D/g, ""))}
            errorMessage={formErrors.maxSize}
          />
          
*/